import CommonHeader from '../../../components/Header.jsx';
import DashboardTabs from './DashboardTabs.jsx';

function renderPrimaryTabs({ primaryTabs, primaryTabActiveIndex }) {
  return (
    <DashboardTabs
      activeIndex={primaryTabActiveIndex}
      items={primaryTabs}
      variant="primary"
      containerClassName="header-primary-tabs"
      tabClassName="header-primary-tab"
    />
  );
}

export default function Header(props) {
  return <CommonHeader {...props} renderPrimaryTabs={renderPrimaryTabs} />;
}
